"use strict";
/**
 * @module Services.Control
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a SET_CLIENT_CONFLATION request.
 */
var SetClientConflationRequest = /** @class */ (function () {
    /**
     * Create a new SetClientConflationRequest instance
     *
     * @param sessionID a session ID
     * @param conflate  enable or disable conflation
     */
    function SetClientConflationRequest(sessionID, conflate) {
        this.sessionID = sessionID;
        this.conflate = conflate;
    }
    return SetClientConflationRequest;
}());
exports.SetClientConflationRequest = SetClientConflationRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/set-client-conflation-request.js
// module id = 1300
// module chunks = 1